module.exports = __webpack_public_path__ + "img/mart4.b72ad1c3.jpeg";